import { Turtle } from "lucide-react";
import { SITE } from "../mock/mock";
import MentionsLegales from "./MentionsLegales";
import { useConsent } from "../context/ConsentContext";

export default function Footer() {
  const { openPreferences } = useConsent();

  return (
    <footer className="bg-[#4a1f42] text-white/80">
      <div className="max-w-6xl mx-auto px-5 md:px-8 py-12">
        <div className="flex flex-col items-center text-center gap-3">
          <span className="flex h-11 w-11 items-center justify-center rounded-full bg-white/10 text-white">
            <Turtle className="h-5 w-5" />
          </span>
          <span className="font-heading text-lg font-extrabold text-white">
            {SITE.title}
          </span>
          <p className="max-w-md text-sm text-white/60">
            Gérard Trèves, la Tortue de Compostelle — « Marcher pour apprendre à
            aimer ».
          </p>
        </div>

        <div className="mt-10 border-t border-white/10 pt-6 flex flex-col sm:flex-row justify-between items-center gap-3 text-xs text-white/50">
          <span>© {new Date().getFullYear()} Gérard Trèves — Tous droits réservés</span>
          <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2">
            <MentionsLegales
              trigger={
                <button className="text-white/60 hover:text-white transition-colors underline-offset-2 hover:underline">
                  Mentions légales
                </button>
              }
            />
            <a
              href="/politique-cookies"
              className="text-white/60 hover:text-white transition-colors underline-offset-2 hover:underline"
            >
              Politique de cookies
            </a>
            <button
              data-testid="footer-manage-cookies"
              onClick={openPreferences}
              className="text-white/60 hover:text-white transition-colors underline-offset-2 hover:underline"
            >
              Gérer mes cookies
            </button>
            <span>gerardlatortuedecompostel.fr</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
